import type {
    ClosingWizardFilePreview,
    ClosingWizardFileState,
} from '../closing-setup-wizard/closing-setup-wizard.types';

/**
 * REV-22007 — the vocabulary of the workspace's file re-import dialog.
 *
 * The SAME shapes as the wizard's upload panel, re-exported under this dialog's name rather than
 * re-declared: both screens show one upload through one slice, and two declarations of "a previewed
 * trial balance" would be two things to keep in step.
 */
export type ErpFileImportState = ClosingWizardFileState;

export type ErpFileImportPreview = ClosingWizardFilePreview;
